import { BaseMediaApiModel } from '@era/inroom-sdk';

import { Action } from '@ngrx/store';

export enum RadioChannelsActionTypes {
  LOAD_RADIO_CHANNELS = '[Radio] Load channels',
}

export class LoadRadioChannels implements Action {
  readonly type = RadioChannelsActionTypes.LOAD_RADIO_CHANNELS;

  constructor(public payload: BaseMediaApiModel[]) {}
}

export type RadioChannelsActionsUnion = LoadRadioChannels;
